import AppSidebar from "components/AppSidebar";
import Header from "components/Header";
import AnnouncementBanner from "components/AnnouncementBanner";
import { SidebarProvider } from "components/ui/sidebar";
import { Toaster } from "components/ui/sonner";
import { useState } from "react";
import type { ReactNode } from "react";

type DashboardLayoutProps = {
  children: ReactNode;
};

const DashboardLayout = ({ children }: DashboardLayoutProps) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <SidebarProvider className="flex min-h-screen w-full font-Inter">
      <Toaster />
      {/* SIDEBAR */}
      <aside
        className={`
          transition-[width] duration-200 ease-linear
          bg-slateblue-dark
          ${sidebarOpen ? "w-[240px]" : "w-0"}
        `}
      >
        <AppSidebar />
      </aside>

      {/* CONTEÚDO */}
      <div className="flex flex-1 flex-col max-h-screen">
        <Header
          sidebarOpen={sidebarOpen}
          toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
        />
        <AnnouncementBanner />

        <main className="flex-1 bg-brand-bg text-brand-text overflow-scroll p-6 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          {children}
        </main>
      </div>
    </SidebarProvider>
  );
};

export default DashboardLayout;
